export default {"src":"/_next/static/media/Male-06.efe98f7d.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};